// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_1istB","cell":"_1lr6J"};